module.exports = " <div data-scrollbottom-notif @click=scrollBottom></div> <stuck-header :header-text=currentHeaderText :date=currentDate :visible=stuckHeaderVisible :header-class=currentHeaderClass></stuck-header> <div class=vue-debug-container> <div class=debug-item v-for=\"item in debugValues\" :style=\"{ top: item.top + 'px' }\"> <span>{{ item.key }}</span> </div> </div> <tabs :mode=mode></tabs> <div class=lists> <race-list v-ref:lists v-for=\"list in lists\" :class=list.class :id=list.id :list=list :empty-text=list.emptyText></race-list> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./site/sites/all/themes/custom/abr_theme/js/race-schedule/components/App.vue
 ** module id = 460
 ** module chunks = 1
 **/